export const SQLITE_ID = 'sqlite';
